export { default as PromotionalBanners } from './PromotionalBanners'
